import React, { ReactNode } from 'react';
import { ProfileData, defaultProfile } from '../firebase/profileService';
import { useProfileQuery } from '../hooks/useProfileQuery';

interface ProfileContextType {
  profile: ProfileData;
  loading: boolean;
  error: Error | null;
  refreshProfile: () => void;
}

// Data lives in the TanStack Query cache; the provider is kept so the app tree doesn't change.
export const ProfileProvider: React.FC<{ children: ReactNode }> = ({ children }) => <>{children}</>;

export const useProfile = (): ProfileContextType => {
  const { data, isPending, error, refetch } = useProfileQuery();

  return {
    profile: data ?? defaultProfile,
    loading: isPending,
    error: error as Error | null,
    refreshProfile: refetch,
  };
};
